import React from 'react'

import { BaseIconProps, IconSizes, IconColors } from '../base'

const NewTab: React.FC<BaseIconProps> = React.forwardRef(
  ({ size = 'md', color = 'default', className }, ref) => (
    <svg
      ref={ref}
      className={className}
      width={IconSizes[size]}
      height={IconSizes[size]}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.50001 4.98502H2.83334C2.09695 4.98502 1.5 5.58253 1.5 6.3196V19.6654C1.5 20.4025 2.09695 21 2.83334 21H16.1667C16.9031 21 17.5 20.4025 17.5 19.6654V13.0325"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 17.015L21.5 1"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5002 1H21.5003V9.00749"
        stroke={IconColors[color]}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
)

export default NewTab
